"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Virtualization_1 = require("./internal/Virtualization");
const Config_1 = require("./Config");
function stateful(proto, prop) {
    const config = { stateful: true };
    return prop ? Virtualization_1.Virt.decorateField(true, config, proto, prop) : Virtualization_1.Virt.decorateClass(true, config, proto);
}
exports.stateful = stateful;
function stateless(proto, prop) {
    const config = { stateful: false };
    return Virtualization_1.Virt.decorateField(true, config, proto, prop);
}
exports.stateless = stateless;
function transaction(proto, prop, pd) {
    const config = { stateful: true };
    return Virtualization_1.Virt.decorateMethod(true, config, proto, prop, pd);
}
exports.transaction = transaction;
function cache(proto, prop, pd) {
    const config = { stateful: true, latency: Config_1.Renew.OnDemand };
    return Virtualization_1.Virt.decorateMethod(true, config, proto, prop, pd);
}
exports.cache = cache;
function behavior(latency, reentrant, separate) {
    return config({ latency, reentrant, separate });
}
exports.behavior = behavior;
function monitor(value) {
    return config({ monitor: value });
}
exports.monitor = monitor;
function trace(value) {
    return config({ trace: value });
}
exports.trace = trace;
function config(value) {
    return function (proto, prop, pd) {
        if (prop && pd)
            return Virtualization_1.Virt.decorateMethod(false, value, proto, prop, pd);
        else if (prop) /* istanbul ignore next */
            return Virtualization_1.Virt.decorateField(false, value, proto, prop);
        else
            return Virtualization_1.Virt.decorateClass(false, value, proto);
    };
}
exports.config = config;
